import withPage from '@lib/withPage'; //  Needed due to Next.JS Bug.... Forces HOC Wrap to avoid "The default export is not a React Component in page: "/product"""
import Page from '@src/components/page';
import Product from '@src/components/product/product.jsx';
import {
	addToCart,
	addToCartUnsafe,
	addToCompare,
	addToWishlist,
	getCategoryProps,
	getProduct as getProductData,
	setNavigation,
	setSelectedProvider,
} from '@src/redux/actions';
import { setLocation } from '@src/redux/actions/geolocation';
import { setSelectedProviderLocation } from '@src/redux/actions/providerLocation';
import { NextSeo, ProductJsonLd } from 'next-seo';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

//  Remove Product out of Redux Linking  Should be passed as a prop
const queryString = require('query-string');
class ProductPage extends Page {
	static propTypes = {
		productId: PropTypes.string,
	};

	constructor(props) {
		super(props);
	}

	static async getInitialProps({ req, store, query: { productid, crossreferenceid, showpriceonly } }) {
		var categoryid = '';
		showpriceonly = showpriceonly ? showpriceonly : false;
		if (productid == null) {
			var parsedUrl = queryString.parseUrl(req.url);
			var slug = parsedUrl.url.split('/');
			var cityUrl = null;
			if (slug.length >= 3) {
				categoryid = slug[2];
			}
			if (slug.length >= 4) {
				// FIXME: cityUrl was missing as variable, what is it used for (V.T. 21.12.2021.)
				cityUrl = slug[3];
			}

			var { crit, store_code } = parsedUrl.query;
		}

		const initState = store.getState();

		await store.dispatch(getProductData(productid, showpriceonly));
		if (crossreferenceid != undefined) {
			categoryid = crossreferenceid;
		}

		await store.dispatch(getCategoryProps(categoryid));
		if (store_code) {
			await store.dispatch(setSelectedProviderLocation(store_code, initState.geolocation));
		}

		return {
			showpriceonly: showpriceonly,
			productid: productid,
			crossreferenceid: crossreferenceid,
		};
	}

	async componentDidUpdate(prevProps, prevState) {
		// TODO: add global loader informing user that something's happening
		// If latitude or longitude got changed
		// Avoids false triggers from before when geolocation objects were compared
		if (
			prevProps.geolocation.latitude !== this.props.geolocation.latitude ||
			prevProps.geolocation.longitude !== this.props.geolocation.longitude
		) {
			await this.props.getProductData(this.props.productid);

			if (this.props.crossreferenceid != 'undefined') {
				// Prioritize fitment information over URL crossreference
				// because URL might be wrong i.e. if user lands on a predefined crossreference but adds a new fitment target (different car model e.g.)
				// in that case their target vehicle is the real target
				const categoryid =
					this.props.fitmentTarget && this.props.fitmentTarget.fullUrlSlug
						? this.props.fitmentTarget.fullUrlSlug
						: this.props.crossreferenceid;
				await this.props.getCategoryProps(categoryid);
			} else {
				await this.props.getCategoryProps('');
			}
		}
	}

	componentDidMount() {
		if (this.props.router) {
			this.props.setNavigation({ previousUrl: this.props.router.asPath });
		}
	}

	render() {
		const { item } = this.props;
		const title = '1-800-Battery';

		let hostname = '1800battery.com';
		if (typeof window !== 'undefined') {
			hostname = window.location.hostname;
		}
		// console.log(this.props.router.asPath);
		return (
			<>
				<NextSeo
					title={`${item?.brand?.brandName} ${item?.name} for ${this.props.applicationLabel} | ${title} `}
					description={`${item?.shortDescription} in Your City.`}
					canonical={`https://${hostname}/product/${this.props.router.query.productid}`}
					openGraph={{
						title: `${item?.brand?.brandName} ${item?.name} for ${this.props.applicationLabel} | ${title}`,
						description: `${item?.shortDescription} in Your City.`,
						images: item?.productPictures?.map(img => ({
							url: img.imageUrl,
						})),
						site_name: `${item?.name} | ${title}`,
					}}
				/>
				<ProductJsonLd
					productName={item.name}
					images={item?.productPictures?.map(img => img.imageUrl)}
					description={item.fullDescription}
					brand={item.brand}
					offers={[
						{
							price: item?.selectedProviderService?.providerId?.Price || item.price,
							priceCurrency: 'USD',
						},
					]}
				/>
				<Product
					renderTransferOverlay={!!this.props.showpriceonly}
					item={item}
					symbol={this.props.symbol}
					addToCart={this.props.addToCart}
					addToCartUnsafe={this.props.addToCartUnsafe}
					addToCompare={this.props.addToCompare}
					addToWishlist={this.props.addToWishlist}
					applicationLabel={this.props.applicationLabel}
					applicationProducts={this.props.applicationProducts}
					crossreferenceid={this.props.crossreferenceid}
					category={this.props.category}
					provider={this.props.provider}
					breadcrumbs={this.props.breadcrumbs}
					setSelectedProvider={this.props.setSelectedProvider}
					geolocation={this.props.geolocation}
					providerLocation={this.props.providerLocation}
					reviews={this.props.reviews}
					productIsLoading={this.props.productIsLoading}
					masterProvider={this.props.masterProvider}
				/>
			</>
		);
	}
}

const mapStateToProps = state => ({
	fitmentTarget: state.category.fitmentTarget,
	geolocation: state.geolocation,
	applicationLabelProduct: state.product.item.applicationLabel,
	item: state.product.item,
	productIsLoading: state.product.isLoading,
	applicationProducts: state.category.products,
	category: state.category,
	applicationBreadcrumbs: state.category.breadcrumbs,
	application: state.category.application,
	applicationLabel: state.category.applicationLabel,
	breadcrumbs: state.category.breadcrumbs,
	provider: state.provider,
	providerLocation: state.providerLocation,
	reviews: state.reviews,
	masterProvider: state.masterProvider,
});

const mapDispatchToProps = {
	addToCartUnsafe,
	addToCart,
	addToWishlist,
	addToCompare,
	getProductData,
	getCategoryProps,
	setSelectedProvider,
	setNavigation,
	setSelectedProviderLocation,
	setLocation,
};

export default withPage(connect(mapStateToProps, mapDispatchToProps)(ProductPage));
